"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalInner", {
    enumerable: true,
    get: function() {
        return ModalInner;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _IframePageInfoContext = require("../../../contexts/IframePageInfoContext");
const _ModalContext = require("../ModalContext");
const _useFloatingInIframe = require("../../../hooks/useFloatingInIframe");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ModalInner = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, className, containerClassName, centered = false, hideOnEsc = true, hideOnClick = true, supportsMobile = false, zIndex } = param;
    const { colors, spacers: { s7, s5 } } = (0, _Theme.useTheme)();
    const { title, scrollable, onHide, show, size } = (0, _react.useContext)(_ModalContext.ModalContext);
    const { inIframe } = (0, _react.useContext)(_IframePageInfoContext.IframeResizerContext);
    const { zIndexes, breakpoints } = (0, _Theme.useTheme)();
    const onKeyDown = (0, _react.useCallback)((e)=>{
        if (e.key === "Escape") {
            e.stopPropagation();
            if (hideOnEsc) {
                onHide();
            }
        }
    }, [
        hideOnEsc,
        onHide
    ]);
    const { position, top, left, floating } = (0, _useFloatingInIframe.useFloatingInIframe)({
        visible: show,
        fixedSize: false,
        placement: centered ? "center" : "top",
        pinToInitialPosition: true,
        offset: 30
    });
    return /*#__PURE__*/ _react.default.createElement("div", {
        onClick: hideOnClick ? onHide : undefined,
        onKeyDown: onKeyDown,
        ref: ref,
        className: _style.default.dynamic([
            [
                "82a1629bf3a5c92e",
                [
                    s7,
                    s5,
                    centered ? "center" : "flex-start",
                    scrollable || inIframe ? "none" : "auto",
                    zIndex !== null && zIndex !== void 0 ? zIndex : zIndexes.modal,
                    position !== null && position !== void 0 ? position : "static",
                    top !== null && top !== void 0 ? top : "0",
                    left !== null && left !== void 0 ? left : "0",
                    colors.border,
                    scrollable && !inIframe ? "100%" : "none",
                    {
                        xs: "300px",
                        sm: "360px",
                        md: "500px",
                        lg: "800px",
                        xl: "1000px",
                        auto: "auto"
                    }[size !== null && size !== void 0 ? size : "auto"],
                    breakpoints.md
                ]
            ]
        ]) + " " + "".concat(containerClassName, " ").concat(supportsMobile && "modal-container--mobile")
    }, /*#__PURE__*/ _react.default.createElement("section", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        ref: floating.floating,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: _style.default.dynamic([
            [
                "82a1629bf3a5c92e",
                [
                    s7,
                    s5,
                    centered ? "center" : "flex-start",
                    scrollable || inIframe ? "none" : "auto",
                    zIndex !== null && zIndex !== void 0 ? zIndex : zIndexes.modal,
                    position !== null && position !== void 0 ? position : "static",
                    top !== null && top !== void 0 ? top : "0",
                    left !== null && left !== void 0 ? left : "0",
                    colors.border,
                    scrollable && !inIframe ? "100%" : "none",
                    {
                        xs: "300px",
                        sm: "360px",
                        md: "500px",
                        lg: "800px",
                        xl: "1000px",
                        auto: "auto"
                    }[size !== null && size !== void 0 ? size : "auto"],
                    breakpoints.md
                ]
            ]
        ]) + " " + "".concat(className, " ").concat(supportsMobile && "modal--mobile")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "82a1629bf3a5c92e",
        dynamic: [
            s7,
            s5,
            centered ? "center" : "flex-start",
            scrollable || inIframe ? "none" : "auto",
            zIndex !== null && zIndex !== void 0 ? zIndex : zIndexes.modal,
            position !== null && position !== void 0 ? position : "static",
            top !== null && top !== void 0 ? top : "0",
            left !== null && left !== void 0 ? left : "0",
            colors.border,
            scrollable && !inIframe ? "100%" : "none",
            {
                xs: "300px",
                sm: "360px",
                md: "500px",
                lg: "800px",
                xl: "1000px",
                auto: "auto"
            }[size !== null && size !== void 0 ? size : "auto"],
            breakpoints.md
        ]
    }, "div.__jsx-style-dynamic-selector{position:fixed;top:0;left:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;width:100%;height:100%;padding:".concat(s7, " ").concat(s5, ";-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:").concat(centered ? "center" : "flex-start", ";-webkit-align-items:").concat(centered ? "center" : "flex-start", ";-moz-box-align:").concat(centered ? "center" : "flex-start", ";-ms-flex-align:").concat(centered ? "center" : "flex-start", ";align-items:").concat(centered ? "center" : "flex-start", ";overflow:").concat(scrollable || inIframe ? "none" : "auto", ";z-index:").concat(zIndex !== null && zIndex !== void 0 ? zIndex : zIndexes.modal, ";-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}div.__jsx-style-dynamic-selector *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}section.__jsx-style-dynamic-selector{position:").concat(position !== null && position !== void 0 ? position : "static", ";top:").concat(top !== null && top !== void 0 ? top : "0", ";left:").concat(left !== null && left !== void 0 ? left : "0", ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;pointer-events:all;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;background:#fff;border:1px solid ").concat(colors.border, ";-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;max-width:90%;max-height:").concat(scrollable && !inIframe ? "100%" : "none", ";width:").concat({
        xs: "300px",
        sm: "360px",
        md: "500px",
        lg: "800px",
        xl: "1000px",
        auto: "auto"
    }[size !== null && size !== void 0 ? size : "auto"], "}@media(max-width:").concat(breakpoints.md, "px){.modal-container--mobile.__jsx-style-dynamic-selector{padding:0;-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end}.modal--mobile.__jsx-style-dynamic-selector{max-width:100%;width:100%;-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomleft:0;border-bottom-left-radius:0;-webkit-border-bottom-right-radius:0;-moz-border-radius-bottomright:0;border-bottom-right-radius:0}}")));
});
ModalInner.displayName = "ModalInner";

//# sourceMappingURL=ModalInner.js.map